import * as React from "react";
import { NavItem, NavLink } from 'reactstrap';
import TableHeaderSection from "../tableHeaderSection/TableHeaderSection";
import TextDataInput from "../textDataInput/TextDataInput";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import PaginationView from "../paginationView/PaginationView";
import { CEDRO_CUSTOMER_NAME } from "../../../home/Consts";
import {
    TEXT_INPUT,
    DROPDOWN_INPUT,
    OPEN_ACTION,
    ADD_NEW_ACTION,
    SEARCH_ACTION,
    REMOVE_ACTION,
    SEARCH_VIEW,
    DEPENDENT_ROW_ACTION,
    DATA_GRID_TABLE_FIELDS_EXPANDER,
    SEARCH_VIEW_CONTRIBUTORS,
    IPI_NUMBER_STATE_KEY,
    READ_ONLY_INPUT,
    CONTRIBUTORS_KEY,
    ADMINISTERED_BY_KEY,
    ADMINISTERED_BY_IP_BASE_NUMBER_STATE_KEY,
    APPLICABLE_WORKS_KEY,
    APPLICABLE_WORK_NAME_STATE_KEY,
    AGREEMENT_CARVEOUTS_KEY,
    AGREEMENT_CARVEOUTS_PRODUCT_NAME_STATE_KEY,
    AGREEMENTS_IP_KEY,
    TABLE_ACTIONS_INSTANCE_KEY,
    MATCHING_REPERTOIRE_WORKS_KEY,
    MATCHING_REPERTOIRE_WORK_NAME_STATE_KEY,
    CODE_ACTION,
    WORK_SUBMISSION,
    WORK_RESPONSE,
    PRODUCT_WORKS_KEY,
    PRODUCT_WORKS_REPERTOIRE_STATE_KEY,
    PRODUCT_CONTRIBUTORS_KEY,
    PRODUCT_CONTRIBUTOR_NAME_STATE_KEY,
    GROUPED_ACTION,
    EMPTY_STRING_VALUE,
    COMPONENTS_KEY,
    COMPONENTS_WORKS_REPERTOIRE_STATE_KEY,
    EDITABLE_FIELDS,
    IS_HIDDEN_FIELD,
    WORK_CONTRIBUTOR_RELATIONSHIPS_STATE_KEY,
    EDITABLE_FIELDS_GRID,
    SEQUENCE_FIELD,
    ORDER_GRID_FIELD_METADATA,
    MATCHING_REPERTOIRE_PRODUCT_NAME_STATE_KEY,
    MATCHING_REPERTOIRE_PRODUCTS_KEY,
    AGREEMENT_DUPLICATE_KEY,
    OPEN_PARENT,
    PARENT_WORK_KEY,
    USAGE_ROWS_SECTION_KEY, USAGE_MATCHING_WORKS_SECTION_KEY, USAGESEARCH_VIEW, MATCHINGWORKS_KEY, MATCHINGPRODUCTS_KEY,
    USAGE_MATCHING_PRODUCTS_SECTION_KEY, ARTISTS_KEY, ARTIST_TYPE_STATE_KEY, PRODUCT_PERFORMERS_KEY, PRODUCT_PERFORMER_NAME_STATE_KEY, ECONOMIC_RIGHT_DESCRIPTION, ECONOMIC_RIGHT, DROPDOWN_TREE_INPUT, DISTRIBUTION_POOLS_KEY, DISTRIBUTION_POOL_CODE_STATE_KEY, DISTRIBUTION_POOL_SELECTION_CRITERIA_STATE_KEY, SELECTION_CRITERIA_VIEW, FOREIGN_SOCIETY_INFO_VIEW, MATCHING_WORK_MORE_INFO_VIEW, IP_LICENSING_REPRESENTATION_KEY, WORK_NOT_FOUND_VIEW, PAYMENTRUN_DISTRIBUTION_CODE_STATE_KEY, USAGE_DETAILS_ROWS_SECTION_KEY, USAGE_DETAILS_ROWS_INBOUNDFEESINERROR, USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR, USAGE_DETAILS_ROWS_SECTION_STATE_KEY, USAGE_DETAILS_ROWS_ACTIONS, LINK_INPUT, USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY, TIME_INPUT, IP_NAMES_SECTION_STATE_KEY, CONTRIBUTOR_COMMENTS_VIEW, IP_NAMES_KEY, CLAIMED_WORKS, COPY_ACTION, WORK_SUBJECT_KEY, WORK_SUBJECT_STATE_KEY, SEARCH_VIEW_SUBJECTS, WORKNUMBER_CORE_OR_EXTERNAL_BOTH, WORKNUMBER_CORE_OR_EXTERNAL_CORE, USAGE_MAINTENANCE_GRIDS_VIEW,
    IP_REPRESENTATION_KEY,
    TERRITORY_SELECTION_VIEW,
    SEARCH_VIEW_IPS,
    DRAFT_AGREEMENTS_PAGE_VIEW,
    SEARCH_VIEW_DRAFT_AGREEMENTS,
    MERGE_ACTION,
    INTEGER_PERCENTAGE_INPUT,
    POOL_SELECTION_VIEW,
    USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY,
    USAGE_MAINTENANCE_COMMENTS_MODAL,
    USAGE_LICENSE_MATCHING,
    OTHER_KEY,
    AGREEMENT_CARVEOUT_PRODUCTS_KEY
} from "../../Consts";
import { createCopyOfTableContents } from "../../services/TableFunctions";
import { IRepertoireField } from "../../types/IRepertoireField";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { hideModal, showWorkSubmission } from "../../../redux/reducers/ModalReducer";
import ShowMore from "../showMore/ShowMore";
import IconTextButton from "../iconTextButton/IconTextButton";
import { SizedActionButton } from "../actionButton/ActionButton";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { ITableAction, ITableActionName, isTableAction } from "../../types/ITableAction";
import { addTab, clearModalSearchResults, updateWorkField, enableCustomField, addUsageDetailsShareIPRow } from "../../../redux/reducers/RepertoireReducer";
import { DataSource } from "../../types/DataSource";
import CheckboxDataInput from "../checkboxDataInput/CheckboxDataInput";
import { ISubmissionPromptViewModalProps } from "../modalViews/workSubmission/WorkSubmission";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { ManualMergeOptions } from "../../types/ManualMergeOptions";
import { IContributorItem } from "../../types/IContributorItem";
import { Dictionary } from "../../../core/types/Dictionary";
import { If } from "../../../core/components/If";
import { RepertoireHelper } from "../../services/RepertoireHelper";
import { ComponentsHelper } from "../../../core/services/ComponentHelper";
import { IAgreementShareDisplayConfiguration } from "../../types/IAgreementShareDisplayConfiguration";
import { DataGridTableRow } from "../usageComponents/dataGridTableRow/DataGridTableRow";
import { UsageRowView } from "../../usage/components/usageRowView/UsageRowView";
import { ITreeData } from "../../types/ITreeData";
import { Space } from "antd";
import { FieldOptions } from "../fieldOptions/FieldOptions";
import { IDistribution } from "../../types/usageTypes/IDistribution";
import { IIpLicensingRepresentation } from "../../types/IIpLicensingRepresentation"
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import { ADD_COVER_VERSION_ACTION, DRAFT_SET_LISTS_WORK_STATE_KEY, ADD_NEW_DATE_ACTION, SET_LISTS_WORK_SEARCHVIEW_STATE_KEY, DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY, DRAFT_AGREEMENT_ASSIGNEE_VIEW, DRAFT_AGREEMENTS_COMMENTS_STATE_KEY } from "../../../membersportal/Consts";
import { IUsagePoolDatesAndDimensions } from "../../types/usageTypes/IUsagePoolDatesAndDimensions";
import { IUsagePool } from "../../types/usageTypes/IUsagePool";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";
import ListenToShortCutKeysDataGridTable, { DO_NOT_SHOW_MODAL } from "./ListenToShortCutKeysDataGridTable";
import { IWorksSearchQuery } from "../../types/IWorksSearchQuery";
import { SELECT_IP } from "../../../membersportal/draftAgreements/components/draftAgreementsAssignee/DraftAgreementsMaintenanceAssigneeView";
import {formatDateToHourAndMinutes} from "../../../membersportal/util/dateHelpers";
import { EXTERNAL_SVG } from "../../IconConsts";
import { IAgreementStateKeys } from "../../../redux/types/IAgreementState";
import { getNewItem, openModalOrNewTab, removeTableItem } from "./utils/dataGridTableActionUtils";
import { getDataInputType } from "./utils/dataGridTableRenderUtils";

export interface IDataGridTableProps {
    tableContents: any;
    changeData?: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void;
    sortData?: (value: any, name: IRepertoireStateKeys) => void;
    dependentRowAction?: (value: any) => void;
    componentInstance: string;
    dataGridTableData: IRepertoireComponentDataItem;
    tableActions?: ITableAction[];
    stateKey: IRepertoireStateKeys;
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string,
        modalMessage?: string,
        isReadOnly?: boolean,
        key?: string,
        index?: number
    )=>void;
    clearModalSearchResults?: typeof clearModalSearchResults | (() => void);
    lookupValues?: ILookupDictionary;
    addTab?: typeof addTab;
    showDropdownsAsCodes?: boolean
    showRowNumber: boolean;
    setTypeGroup?: string;
    activeSetType?: string;
    dataSource?: DataSource;
    isReadOnly?: boolean;
    openInNewTab?: (openItem: any) => void;
    openInSplitScreen?: (openItem: any) => void;
    showWorkSubmissionDetail?: typeof showWorkSubmission;
    hideModal?: typeof hideModal;
    tabs?: ITabReduxItem[];
    activeTab?: number;
    currentUser?: string;
    groupActionClick?: (action: any, tableContentItem: any) => void;
    contributorConfiguration?: string;
    updateContributorRelationships?: (value: string, contributors: IContributorItem[], rowIndex: number) => void;
    updateWorkField?: typeof updateWorkField;
    customFields?: number[];
    enableCustomField?: typeof enableCustomField;
    showFieldsModal?: () => void;
    agreementShareDisplayOptions?: IAgreementShareDisplayConfiguration
    shareDecimalsToDisplay?: number;
    isExpandable?: boolean;
    usageType?: string;
    lookupSources?: ITreeData[];
    addNewAccount?: () => void;
    poolCodes?: string[];
    distributionCodes?: string[];
    distributions?: IDistribution[];
    clearAllRowsButThis?: (value: any) => void;
    expandedWorkResults?: number[];
    expandedProductResults?: number[];
    expandMatchingWork?: (index: number) => void;
    expandMatchingProduct?: (index: number) => void;
    expandUsageDetailRow?: (index: number) => void;
    allowMultiSelectChbk?: boolean;
    isBulkCheckboxActive?: boolean;
    changeBulkCheckbox?: (value: boolean) => void;
    incrementTempID?: () => void;
    entity?: any;
    onClickAddUsageDetails?: (index: number) => void;
    addUsageDetailsShareIPRow?: typeof addUsageDetailsShareIPRow;
    portalType?: string;
    resetMessageBanner?: () => void;
    openWorkFlow?: boolean;
    datesAndDimensions?: IUsagePoolDatesAndDimensions[];
    usagePoolsSearchResults?: IUsagePool[];
    poolCode?: string;
    sources?: ITreeData[];
    getUsagePool?: (poolId: number, matchingSources: ITreeData[]) => void;
    pool?: IUsagePoolState;
    isExpandedUsageMatchingSection?: boolean;
    expandedUsageDetailsRow?: number[];
    creationClassOptions?: any[];
    customer?: string;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    updateDraftAgreementWorkField?: (value: any, fieldName: IAgreementStateKeys, index?: number) => void;
    mergeActionClick?: (tableContentItem: any) => void;
    isBackendSearchEnabled?: boolean;
    onBackendSearch?: (value: string, e?: any) => void;
    checkableColumns?: string[];
    checkedColumns?: string[];
    toggleHeaderCheckbox?: (fieldName: string, isChecked: boolean) => void;
    customComponentOnClickAdd?: () => void;
    onClickCopy?: () => void;
    isRowSelectionEnabled?: boolean;
}

interface IDataGridTableState {
    activeSortHeaderSection: string;
    focusedRow: number;
    searchModalName: string;
    isRemoveAction: boolean;
    indexOfFirstResult: number;
    indexOfLastResult: number;
    currentPage: number;
    resultsPerPage: number;
    checkedColumns: string[];
}

export default class DataGridTable extends React.PureComponent<
    IDataGridTableProps,
    IDataGridTableState
> {
    componentRef;
    constructor(props: IDataGridTableProps) {
        super(props);

        this.componentRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.state = {
            activeSortHeaderSection: undefined,
            focusedRow: null,
            searchModalName: DO_NOT_SHOW_MODAL,
            isRemoveAction: false,
            indexOfFirstResult: 0,
            indexOfLastResult: 0,
            currentPage: 1,
            resultsPerPage: 50,
            checkedColumns: props.checkedColumns || [],
        };
        const { usagePoolsSearchResults, poolCode, sources, getUsagePool } = this.props;
        if (usagePoolsSearchResults) {
            const findX = usagePoolsSearchResults.find(x => x.poolCode === poolCode)
            if (findX)
                getUsagePool(findX.poolId, sources);
        }
    }

    setTheSearchModalTypeShortCutKeyListening = (stateKey) => {
        const { dataSource } = this.props;
        switch (stateKey) {
            case CONTRIBUTORS_KEY:
                this.setState({ searchModalName: CONTRIBUTORS_KEY });
                return;
            case PRODUCT_CONTRIBUTORS_KEY:
                this.setState({ searchModalName: PRODUCT_CONTRIBUTORS_KEY });
                return;
            case APPLICABLE_WORKS_KEY:
                this.setState({ searchModalName: APPLICABLE_WORKS_KEY })
            case MATCHING_REPERTOIRE_WORKS_KEY:
                this.setState({ searchModalName: MATCHING_REPERTOIRE_WORKS_KEY })
                return;
            case MATCHING_REPERTOIRE_PRODUCTS_KEY:
                this.setState({ searchModalName: MATCHING_REPERTOIRE_PRODUCTS_KEY })
                return;
            case ARTISTS_KEY:
                if (dataSource === DataSource.Intray) {
                    this.setState({ searchModalName: ARTISTS_KEY })
                    return;
                }
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
                return;
            case PRODUCT_PERFORMERS_KEY:
                if (dataSource === DataSource.Intray) {
                    this.setState({ searchModalName: PRODUCT_PERFORMERS_KEY })
                    return;
                }
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
                return;
            case AGREEMENTS_IP_KEY:
            case ADMINISTERED_BY_KEY:
                this.setState({ searchModalName: AGREEMENTS_IP_KEY })
                return;
            default:
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
        }
    }

    handleClickOutside(event: any) {
        if (this.componentRef.current && !this.componentRef.current.contains(event.target)) {
            this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
            this.setState({ focusedRow: null })
            return;
        }
    }

    componentDidMount() {
        const { componentInstance, dataGridTableData } = this.props;
        this.setTheSearchModalTypeShortCutKeyListening(componentInstance)
        const filteredFields = dataGridTableData && dataGridTableData?.fields.filter(field => field.componentInstance === componentInstance);
        if (filteredFields?.filter(field => field.fieldType === REMOVE_ACTION).length > 0) {
            this.setState({ isRemoveAction: true });
        }
    }

    onRowClick = (rowNumber) => {

        const { componentInstance, expandUsageDetailRow } = this.props;
        this.setState({ focusedRow: rowNumber });
        this.setTheSearchModalTypeShortCutKeyListening(componentInstance);
        if (expandUsageDetailRow) {
            expandUsageDetailRow(rowNumber);
        }
    }

    addRowShortCutKeys = () => {
        const { focusedRow } = this.state;

        const { tableActions } = this.props;
        if ((focusedRow === 0 || focusedRow) && tableActions && tableActions.filter(action => action.name === ADD_NEW_ACTION)?.length > 0) {
            this.onClickAdd();
        }
    }

    deleteRowShortCutKeys = () => {
        const { focusedRow, isRemoveAction } = this.state;
        const { tableContents } = this.props;
        if ((focusedRow === 0 || focusedRow) && isRemoveAction) {
            this.onClickRemove(tableContents[focusedRow])
        }
    }

    showSearchModalShortCutKey = () => {
        const { focusedRow, searchModalName } = this.state;
        const { tableContents } = this.props;

        if (searchModalName !== DO_NOT_SHOW_MODAL) {
            this.showSearchModal(tableContents[focusedRow], searchModalName)
        }

    }

    public ascending: boolean = false;
    public ipRepresentationsIdsToRemove: number[] = [];
    public updatedIpLicensingRepresentations: IIpLicensingRepresentation[] = [];

    sortTableByColumn = (section: string) => {
        const { activeSortHeaderSection } = this.state;
        const { tableContents, sortData, stateKey, componentInstance, tabs, activeTab, activeSetType } = this.props;
        let fullTableContentsCopy: Dictionary<IContributorItem[]>;
        let tableContentsCopy: any;

        if (stateKey === SEARCH_VIEW_CONTRIBUTORS) {
            fullTableContentsCopy = tabs[activeTab].workMaintenanceState.work.contributors;
            tableContentsCopy = fullTableContentsCopy[activeSetType];
        }
        else {
            tableContentsCopy = JSON.parse(JSON.stringify(tableContents));
        }

        if (activeSortHeaderSection !== section) {
            this.ascending = false;
        }
        if (tableContentsCopy) {
            tableContentsCopy.sort((a: any, b: any) => {
                // set to emtpy string if null
                const newA = a[section] ? (a[section].value ? a[section].value : a[section]) || "" : "";
                const newB = b[section] ? (b[section].value ? b[section].value : b[section]) || "" : "";

                if (!this.ascending) {
                    return newA.toString().localeCompare(newB.toString(), undefined, { 'numeric': true });
                }
                return newB.toString().localeCompare(newA.toString(), undefined, { 'numeric': true });
            });
        }

        this.setState({ activeSortHeaderSection: section });
        if (componentInstance === SEARCH_VIEW_CONTRIBUTORS) {
            fullTableContentsCopy[activeSetType] = tableContentsCopy;
            sortData(fullTableContentsCopy, stateKey);
        } else {
            sortData(tableContentsCopy, stateKey);
        }
        this.ascending = !this.ascending;
    };

    changeTableData = (
        value: any,
        stateKey: IRepertoireStateKeys,
        objectKey: string,
        rowIndex: number,
        componentInstance?: string,
        newOrderValue?: string
    ) => {
        const { changeData, tableContents, updateContributorRelationships, datesAndDimensions, checkableColumns = [] } = this.props;
        const tableContentsCopy = createCopyOfTableContents(tableContents, (componentInstance === undefined || componentInstance.length > 0) ? true : false);
        if (stateKey === MATCHING_REPERTOIRE_WORKS_KEY && objectKey == "isDefinite") {
            if (tableContentsCopy.length > 1) {
                tableContentsCopy[rowIndex][objectKey].value = value;
                for (let i = 0; i < tableContentsCopy.length; i++) {
                    if (i != rowIndex) {
                        tableContentsCopy[i][objectKey].value = false
                    }
                }
            }
            else {
                tableContentsCopy[rowIndex][objectKey].value = value;
            }
        }
        if (stateKey === CONTRIBUTORS_KEY && objectKey === WORK_CONTRIBUTOR_RELATIONSHIPS_STATE_KEY) {
            updateContributorRelationships(value, tableContentsCopy, rowIndex);
            return;
        }
        else if (objectKey === "workName") {
            tableContentsCopy[rowIndex][objectKey].value = value;
            tableContentsCopy[rowIndex]["workNumber"].value = tableContentsCopy[rowIndex].productWorks[0].number
            tableContentsCopy[rowIndex]["workId"] = tableContentsCopy[rowIndex].productWorks[0].workCode
        }
        else if (stateKey === CONTRIBUTORS_KEY && objectKey == "relationships") {
            tableContentsCopy[rowIndex][objectKey].value = value
        }
        else if (stateKey === CONTRIBUTORS_KEY && objectKey == "societyOfLicense") {
            tableContentsCopy[rowIndex][objectKey].value = value
        }
        else if (componentInstance === EDITABLE_FIELDS) {
            stateKey = componentInstance;
            if (objectKey === IS_HIDDEN_FIELD) {
                tableContentsCopy[rowIndex].hidden = !tableContentsCopy[rowIndex].hidden;
            }
            else if (objectKey === "defaultValue") {
                tableContentsCopy[rowIndex].defaultValue = value;
            }
            else if (objectKey === 'isMandatory') {
                tableContentsCopy[rowIndex].isMandatory = value;
            }
            else {
                tableContentsCopy[rowIndex].data = value;
            }
            tableContentsCopy[rowIndex].modifiedByUser = true;
        }
        else if (componentInstance === EDITABLE_FIELDS_GRID) {
            stateKey = componentInstance;
            if (objectKey === IS_HIDDEN_FIELD) {
                tableContentsCopy[rowIndex].hidden = !tableContentsCopy[rowIndex].hidden;
                tableContentsCopy[rowIndex].modifiedByUser = true;
            }
            else if (objectKey === SEQUENCE_FIELD) {
                const orders = tableContents.map(x => x[ORDER_GRID_FIELD_METADATA]);
                const newOrder = parseInt(newOrderValue);
                if (newOrder > rowIndex) {

                    tableContentsCopy[rowIndex][ORDER_GRID_FIELD_METADATA] = orders[newOrder];

                    for (let i = rowIndex; i < newOrder; i++) {
                        tableContentsCopy[i + 1][ORDER_GRID_FIELD_METADATA] = orders[i];
                    }
                }
                else if (newOrder < rowIndex) {

                    tableContentsCopy[rowIndex][ORDER_GRID_FIELD_METADATA] = orders[newOrder];

                    for (let i = newOrder; i < rowIndex; i++) {
                        tableContentsCopy[i][ORDER_GRID_FIELD_METADATA] = orders[i + 1];
                    }
                }
                tableContentsCopy[rowIndex].modifiedByUser = true;
            }
            else {
                tableContentsCopy[rowIndex].data = value;
            }
        }
        else if (componentInstance === COMPONENTS_KEY) {
            stateKey = componentInstance;
            tableContentsCopy[rowIndex][objectKey].value = value;
        }
        else if (componentInstance === PRODUCT_WORKS_KEY) {
            stateKey = componentInstance;
            tableContentsCopy[rowIndex][objectKey].value = value;
        }
        else if (stateKey === USAGE_ROWS_SECTION_KEY) {
            tableContentsCopy[rowIndex][objectKey] = value;
        }
        else if (stateKey === USAGE_DETAILS_ROWS_SECTION_STATE_KEY || stateKey === IP_NAMES_SECTION_STATE_KEY) {
            tableContentsCopy[rowIndex][objectKey] = value;
        }
        else if (componentInstance === "comments" || componentInstance ===  USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY) {
            tableContentsCopy[rowIndex][objectKey].value = value;
            tableContentsCopy[rowIndex]['isModified'] = true;
        }
        else {
            tableContentsCopy[rowIndex][objectKey].value = value;
        }
        
        if (objectKey === 'effectiveDateRange') {
            tableContentsCopy[rowIndex][objectKey].value = value;
            const result = datesAndDimensions.find((word) => word.effectiveDateRange === value);
            tableContentsCopy[rowIndex]['dimensionsAndDatesID'] = result.poolDimensionsAndDatesID;
            tableContentsCopy[rowIndex]['use'].inputType = result.use ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['usageDimensionOne'].inputType = result.dimension1 ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['usageDimensionTwo'].inputType = result.dimension2 ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['usageDimensionThree'].inputType = result.dimension3 ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['usageDimensionFour'].inputType = result.dimension4 ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['usageDimensionFive'].inputType = result.dimension5 ? TEXT_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['fromTime'].inputType = result.time ? TIME_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['toTime'].inputType = result.time ? TIME_INPUT : READ_ONLY_INPUT;
            tableContentsCopy[rowIndex]['musicSource'].inputType = result.musicSource ? TEXT_INPUT : READ_ONLY_INPUT;

            tableContentsCopy[rowIndex]['use'].value = result.use ? tableContentsCopy[rowIndex]['use'].value : '';
            tableContentsCopy[rowIndex]['usageDimensionOne'].value = result.dimension1 ? tableContentsCopy[rowIndex]['usageDimensionOne'].value : '';
            tableContentsCopy[rowIndex]['usageDimensionTwo'].value = result.dimension2 ? tableContentsCopy[rowIndex]['usageDimensionTwo'].value : '';
            tableContentsCopy[rowIndex]['usageDimensionThree'].value = result.dimension3 ? tableContentsCopy[rowIndex]['usageDimensionThree'].value : '';
            tableContentsCopy[rowIndex]['usageDimensionFour'].value = result.dimension4 ? tableContentsCopy[rowIndex]['usageDimensionFour'].value : '';
            tableContentsCopy[rowIndex]['usageDimensionFive'].value = result.dimension5 ? tableContentsCopy[rowIndex]['usageDimensionFive'].value : '';
            tableContentsCopy[rowIndex]['fromTime'].value = result.time ? tableContentsCopy[rowIndex]['fromTime'].value : '';
            tableContentsCopy[rowIndex]['toTime'].value = result.time ? tableContentsCopy[rowIndex]['toTime'].value : '';
            tableContentsCopy[rowIndex]['musicSource'].value = result.musicSource ? tableContentsCopy[rowIndex]['musicSource'].value : '';
        }

        if (checkableColumns.includes(objectKey)) {
            const allChecked = value && tableContents?.length > 0 && tableContents.every(item => item[objectKey]?.value);
            this.toggleHeaderCheckbox(objectKey, allChecked);
        }

        changeData(tableContentsCopy, stateKey, objectKey);
    };

    changeTableDataForMultiSelect = (value: any, fieldName: string) => {
        const { tableContents, changeBulkCheckbox } = this.props;
        changeBulkCheckbox(value);
        for (let i = 0; i < tableContents.length; i++) {
            tableContents[i][fieldName].value = value;
        }
    };

    handleHeaderCheckboxChange = (fieldName: string, isChecked: boolean) => {
        this.setState(
            prevState => ({
                checkedColumns: isChecked
                    ? [...prevState.checkedColumns, fieldName]
                    : prevState.checkedColumns.filter(column => column !== fieldName),
            }),
            () => {
                const { tableContents, toggleHeaderCheckbox } = this.props;
                if (tableContents?.length) {
                    toggleHeaderCheckbox(fieldName, isChecked);
                    tableContents.forEach(row => row[fieldName].value = isChecked);
                }
            }
        );
    };

    toggleHeaderCheckbox = (fieldName: string, isChecked: boolean) => {
        const { toggleHeaderCheckbox } = this.props;
        this.setState(
            ({ checkedColumns }) => ({
                checkedColumns: isChecked
                    ? [...checkedColumns, fieldName]
                    : checkedColumns.filter(column => column !== fieldName),
            }),
            () => toggleHeaderCheckbox(fieldName, isChecked)
        );
    };

    changeDataForLivePerformance = (data: string) => {
        if (data === "Program Start Date" || data === "Program End Date")
            return data.replace("Date", "Time");
        return data
    }

    onClickRemove = (tableContentItem: any) => {
        const { changeData, stateKey, tableContents, tabs, activeTab, componentInstance } = this.props;
        removeTableItem(changeData, stateKey, tableContents, tabs, activeTab, componentInstance, this.ipRepresentationsIdsToRemove, tableContentItem);
    } 

    onClickOpen = (field: IRepertoireField, tableContentItem: any) => {
        const { showModal, openInNewTab, isReadOnly } = this.props;
        openModalOrNewTab(field.componentInstance, tableContentItem, field.data, showModal, openInNewTab, isReadOnly);
    }

    updateIpRepresentationsIdsToRemove = (tableContentItem: any): number[] => {
        const { tabs, activeTab } = this.props;

        if (activeTab) {
            this.ipRepresentationsIdsToRemove = tabs[activeTab].interestedPartyMaintenanceState?.representationIds ?? [];
        }
        else {
            this.ipRepresentationsIdsToRemove = [];
        }

        let ipLicensingRepresentation: any = tableContentItem ? tableContentItem as IIpLicensingRepresentation : undefined;

        if (ipLicensingRepresentation !== undefined || ipLicensingRepresentation.id !== undefined) {
            this.ipRepresentationsIdsToRemove.push(ipLicensingRepresentation.id);
        }

        return this.ipRepresentationsIdsToRemove;
    }

    onClickAdd = () => {
        const { 
            changeData, stateKey, tableContents, setTypeGroup, activeSetType, componentInstance, 
            lookupValues, currentUser, incrementTempID, tabs, activeTab, portalType, customComponentOnClickAdd
        } = this.props;

        let nextTempID: number = tabs[activeTab].nextTempID;

        if (nextTempID === undefined) {
            nextTempID = 0;
            tabs[activeTab].nextTempID = nextTempID;
        }

        let tableContentsCopy: any = tableContents ? createCopyOfTableContents(tableContents) : [];
        let newItem: any;

        if(customComponentOnClickAdd){
            customComponentOnClickAdd();
        } else {
            newItem = getNewItem(componentInstance, nextTempID, currentUser, portalType, lookupValues, activeSetType, setTypeGroup);
            if (newItem != null) {
                tableContentsCopy.push(newItem);
            }
            changeData(tableContentsCopy, stateKey);
            incrementTempID()
        }
    };

    onOpenCodeModel = (submission: string, type: string) => {
        const { showWorkSubmissionDetail, hideModal } = this.props;
        const field = JSON.stringify(JSON.parse(submission), null, 2)
        const props: ISubmissionPromptViewModalProps = {
            hideCallback: () => { hideModal() },
            field: field === 'null' ? '' : field,
            title: type
        }
        showWorkSubmissionDetail(submission, props);
    }

    renderLineBreak = (array: string[]) => {
        return (
            <div>
                {array.map((item, index) => (
                    <div key={index}>
                        {item}
                        {index + 1 !== array.length ? <span>,</span> : null}
                    </div>
                ))}
            </div>
        );
    }

    getTableSections = (tableContentItem: any, index: number) => {
        const { dataGridTableData, componentInstance, showRowNumber, stateKey, agreementShareDisplayOptions, isReadOnly, shareDecimalsToDisplay, dataSource, isExpandable, customer, activeSetType } = this.props;
        let currentComponentInstance = componentInstance;

        if (componentInstance === SET_LISTS_WORK_SEARCHVIEW_STATE_KEY) {
            currentComponentInstance = DRAFT_SET_LISTS_WORK_STATE_KEY;
        }
        if (dataGridTableData && dataGridTableData.fields) {
            let filteredFields: IRepertoireField[] = dataGridTableData.fields.filter(
                (field: IRepertoireField) => field.componentInstance && field.componentInstance === currentComponentInstance);
            const expanderFields = dataGridTableData.fields.filter(
                (field: IRepertoireField) => field.componentInstance && field.componentInstance === DATA_GRID_TABLE_FIELDS_EXPANDER);
            const dependentFields = dataGridTableData.fields.filter(
                (field: IRepertoireField) => field.componentInstance && field.componentInstance.startsWith(currentComponentInstance + '.'));
            const dependentFieldKey: string = dependentFields && dependentFields.length > 0 && dependentFields[0].componentInstance.split('.')[1];

            if (currentComponentInstance === CONTRIBUTORS_KEY || currentComponentInstance === IP_NAMES_KEY) {
                filteredFields = filteredFields.filter(x => !x.hidden);
                if (activeSetType != 'other') {
                    filteredFields = filteredFields.filter(x => x.name != 'includeTerritories' && x.name != 'excludeTerritories');
                }

            }

            if (currentComponentInstance === CONTRIBUTORS_KEY) {
                filteredFields = ComponentsHelper.orderFieldsBySpecificField(filteredFields as IRepertoireField[], ORDER_GRID_FIELD_METADATA);
            }

            const sections: JSX.Element[] = [];
            const dependentSections: JSX.Element[] = [];

            if (showRowNumber && currentComponentInstance !== IP_LICENSING_REPRESENTATION_KEY) {
                sections.splice(0, 0, <td key='rowNumber' className="rowNumber">
                    <div className="tableCell">
                        {index + 1}
                    </div>
                </td>);
            }
            filteredFields.map((field) => {
                const key = field.name;
                if ((stateKey === CONTRIBUTORS_KEY && key === IPI_NUMBER_STATE_KEY)
                    || (stateKey === ADMINISTERED_BY_KEY && key === ADMINISTERED_BY_IP_BASE_NUMBER_STATE_KEY)
                    || (stateKey === APPLICABLE_WORKS_KEY && key === APPLICABLE_WORK_NAME_STATE_KEY)
                    || (stateKey === AGREEMENT_CARVEOUTS_KEY && key === AGREEMENT_CARVEOUTS_PRODUCT_NAME_STATE_KEY)
                    || (stateKey === PRODUCT_CONTRIBUTORS_KEY && key === PRODUCT_CONTRIBUTOR_NAME_STATE_KEY)
                    || (dataSource === DataSource.Intray && stateKey === ARTISTS_KEY && key === ARTIST_TYPE_STATE_KEY)
                    || (dataSource === DataSource.Intray && stateKey === PRODUCT_PERFORMERS_KEY && key === PRODUCT_PERFORMER_NAME_STATE_KEY)
                    || (stateKey === DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY && key === "workName")) {
                    sections.push(this.renderFieldOptions(field, tableContentItem, index));
                }
                else if ((stateKey === MATCHING_REPERTOIRE_WORKS_KEY) && !isTableAction(field.fieldType)) {
                    if (key === MATCHING_REPERTOIRE_WORK_NAME_STATE_KEY) {
                        sections.push(this.renderFieldOptions(field, tableContentItem, index));
                    } else {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props, tableContentItem[key], key, index, field.fieldType, false)}
                            </td>
                        );

                    }
                }
                else if (stateKey === WORK_SUBJECT_KEY && key === WORK_SUBJECT_STATE_KEY) {
                    sections.push(
                        <td key={field.name} title={field.data}>
                            <div className="tableCell hasIcon" style={{ display: 'flex', alignItems: 'center', marginTop: '4px', paddingLeft: '4px' }}>
                                <TextDataInput
                                    value={tableContentItem[field.name].value}
                                    fieldName={field.name}
                                    changeData={(value, stateKey) => this.changeTableData(tableContentItem[field.name].value, field.name, field.data, index)}
                                    readOnly={true}
                                    isHidden={true}
                                />
                                <ShowMore
                                    options={!isReadOnly && [
                                        {
                                            text: expanderFields.find(e => e.name === "selectSubject").data,
                                            onClick: () => { this.showSearchModal(tableContentItem, SEARCH_VIEW_SUBJECTS) },
                                            icon: EXTERNAL_SVG
                                        }
                                    ]}
                                />
                            </div>
                        </td>
                    );
                }
                else if ((stateKey === MATCHING_REPERTOIRE_PRODUCTS_KEY) && !isTableAction(field.fieldType)) {
                    if (key === MATCHING_REPERTOIRE_PRODUCT_NAME_STATE_KEY) {
                        sections.push(this.renderFieldOptions(field, tableContentItem, index));
                    } else {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props, tableContentItem[key], key, index, field.fieldType, false)}
                            </td>
                        );

                    }
                }
                else if ((customer === CEDRO_CUSTOMER_NAME && stateKey === DISTRIBUTION_POOLS_KEY && key === 'poolCode')) {
                    sections.push(
                        <td key={key} title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['poolCode'], key, index, DROPDOWN_INPUT, false)}
                        </td>
                    );
                }

                else if ((stateKey === CONTRIBUTORS_KEY && key === 'perfPercentage')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['performingShareToDisplay'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === CONTRIBUTORS_KEY && key === 'mechPercentage')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['mechanicalShareToDisplay'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'performingShare') || (stateKey === ADMINISTERED_BY_KEY && key === 'performingShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['performingShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'creatorRetainedPerShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['creatorRetainedPerShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'publisherRetainedPerShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['publisherRetainedPerShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === ADMINISTERED_BY_KEY && key === 'creatorRetainedPerShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['creatorRetainedPerShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if (stateKey === ADMINISTERED_BY_KEY && key === 'publisherRetainedPerShare') {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['publisherRetainedPerShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'mechanicalShare') || (stateKey === ADMINISTERED_BY_KEY && key === 'mechanicalShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['mechanicalShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'creatorRetainedMechShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['creatorRetainedMechShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === 'publisherRetainedMechShare')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['publisherRetainedMechShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if (stateKey === ADMINISTERED_BY_KEY && key === 'creatorRetainedMechShare') {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['creatorRetainedMechShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if (stateKey === ADMINISTERED_BY_KEY && key === 'publisherRetainedMechShare') {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['publisherRetainedMechShare'], key, index, INTEGER_PERCENTAGE_INPUT, false)}
                        </td>
                    );
                }
                else if ((stateKey === CONTRIBUTORS_KEY && key === 'contributorComments')) {
                    const { isReadOnly, openInNewTab, showModal } = this.props;
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            <div className="contributor-comment">
                                <IconTextButton
                                    icon={"ms-Icon ms-Icon--Chat"}
                                    text={""}
                                    onClick={() => this.onClickOpen(field, tableContentItem)}
                                />
                            </div>
                        </td>
                    )
                }
                else if ((stateKey === CONTRIBUTORS_KEY && key === 'relation')) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['relation'], key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if ((stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && key === USAGE_DETAILS_ROWS_INBOUNDFEESINERROR)) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['inboundFeesInError'], key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if ((stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && key === USAGE_DETAILS_ROWS_OUTBOUNDFEESINERROR)) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['outboundFeesInError'], key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if ((stateKey === USAGE_DETAILS_ROWS_SECTION_KEY && key === USAGE_DETAILS_ROWS_ACTIONS)) {
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props,USAGE_DETAILS_ROWS_ACTIONS, key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if ((stateKey === DISTRIBUTION_POOLS_KEY && key === 'amountToAllocate')) {

                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['amountToAllocate'], key, index, field.fieldType, false, null, 0)}
                        </td>
                    );
                }
                else if ((stateKey === DISTRIBUTION_POOLS_KEY && key === 'nominalValuePerPoint')) {

                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['nominalValuePerPoint'], key, index, field.fieldType, false, null, 0)}
                        </td>
                    );
                }
                else if ((stateKey === CONTRIBUTORS_KEY && key === 'copyLevyPercentage')) {
                    tableContentItem['copyLevyPercentage'].value = RepertoireHelper.trailingZeroesForShares(tableContentItem['copyLevyPercentage'].value, shareDecimalsToDisplay)
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['copyLevyPercentage'], key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if ((stateKey === CONTRIBUTORS_KEY && key === 'copyLicencePercentage')) {
                    tableContentItem['copyLicencePercentage'].value = RepertoireHelper.trailingZeroesForShares(tableContentItem['copyLicencePercentage'].value, shareDecimalsToDisplay)
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props, tableContentItem['copyLicencePercentage'], key, index, field.fieldType, false)}
                        </td>
                    );
                }
                else if (stateKey === AGREEMENT_DUPLICATE_KEY && key === "repertoireAgreementID") {
                    sections.push(
                        <td key={field.name} title={field.data}>
                            <div className="tableCell hasIcon">
                                <TextDataInput
                                    value={tableContentItem[field.name].value}
                                    fieldName={field.name}
                                    changeData={(value, stateKey) => this.changeTableData(tableContentItem[field.name].value, field.name, field.data, index)}
                                    readOnly={true}
                                    isHidden={true}
                                />
                                <ShowMore
                                    options={!isReadOnly && [
                                        {
                                            text: expanderFields.find(e => e.name === "openAgreement").data,
                                            onClick: () => { this.props.openInNewTab(tableContentItem) },
                                            icon: EXTERNAL_SVG
                                        }
                                    ]}
                                />
                            </div>
                        </td>
                    )
                }
                else if (stateKey === DRAFT_AGREEMENTS_COMMENTS_STATE_KEY && key === "comment") {
                    sections.push(
                        <td key={key} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        //tablecontentitem stops all table data being passed
                                        options={[
                                            {
                                                text: "Expand Comment",
                                                onClick: () => { this.showSearchModal(tableContentItem, SEARCH_VIEW_DRAFT_AGREEMENTS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[key].value}
                                        fieldName={key}
                                        changeData={(value, stateKey) => this.changeTableData(value, stateKey, key, index)}
                                        readOnly={isReadOnly}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    );
                }
                else if (stateKey === USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY && key === "comment") {
                    sections.push(
                        <td key={key} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        options={[
                                            {
                                                text: "Expand Comment",
                                                onClick: () => { this.showSearchModal(tableContentItem, SEARCH_VIEW_DRAFT_AGREEMENTS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[key].value}
                                        fieldName={key}
                                        changeData={(value, stateKey) => {
                                            this.changeTableData(value, stateKey, key, index)}}
                                        readOnly={isReadOnly}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    );
                }
                else if (stateKey === DRAFT_AGREEMENT_ASSIGNEE_VIEW && key === "assigneeNameNumber") {
                    sections.push(
                        <td key={key} className="td">
                            <div style={{ position: 'relative', zIndex: 1000 }}>
                                <div style={{ position: 'absolute', display: 'flex', alignItems: 'center', right: -15, top: '50%', transform: 'translateY(-50%)' }}>
                                    <ShowMore
                                        options={[
                                            {
                                                text: SELECT_IP,
                                                onClick: () => { this.showSearchModal(SEARCH_VIEW, SEARCH_VIEW_IPS, index) },
                                                icon: EXTERNAL_SVG
                                            }
                                        ]}
                                    />
                                </div>
                                <div className="input-container">
                                    <TextDataInput
                                        value={tableContentItem[key].value}
                                        fieldName={key}
                                        changeData={(value, stateKey) => this.changeTableData(value, stateKey, key, index)}
                                        readOnly={true}
                                        isHidden={false}
                                    />
                                </div>
                            </div>
                        </td>
                    );
                }
                else if ((stateKey === IP_REPRESENTATION_KEY || (stateKey === CONTRIBUTORS_KEY && tableContentItem.setType == 'other')) && key === "includeTerritories") {
                    sections.push(this.renderFieldOptions(field, tableContentItem, index));
                }
                else if ((stateKey === IP_REPRESENTATION_KEY || (stateKey === CONTRIBUTORS_KEY && tableContentItem.setType == 'other')) && key === "excludeTerritories") {

                    sections.push(this.renderFieldOptions(field, tableContentItem, index));
                }
                else if (stateKey === IP_REPRESENTATION_KEY && key === "includePools" ) {
                    sections.push(this.renderFieldOptions(field, tableContentItem, index));
                }
                else if (stateKey === IP_REPRESENTATION_KEY && key === "excludePools") {
                    sections.push(this.renderFieldOptions(field, tableContentItem, index));
                }
                else if (isTableAction(field.fieldType)) {
                    sections.push(this.renderRowAction(tableContentItem, field))
                }
                else if (stateKey === EDITABLE_FIELDS) {
                    const nameField = tableContentItem["name"];
                    const item = {
                        value: tableContentItem["data"], inputType: field.fieldType, hidden: tableContentItem["hidden"] as boolean,
                        name: nameField, isReadOnly: false, defaultValue: tableContentItem["defaultValue"],
                        isMandatory: tableContentItem["isMandatory"], isMandatoryModifiable: tableContentItem["isMandatoryModifiable"]
                    }
                    const disabled = field.name === "defaultValue" && (tableContentItem["fieldType"] === "dropdown" || tableContentItem["fieldType"] === "multiselect");
                    sections.push(
                        <td key={`${key}_${item["name"]}`} className="td col-lg-3 col-md-3 col-sm-3 col-xs-3" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props,item, field.name, index,
                                field.fieldType, tableContentItem["hidden"] as boolean,
                                undefined, undefined, !disabled)}
                        </td>
                    );
                }
                else if (stateKey === CLAIMED_WORKS && key === 'workNumbers') {
                    if (tableContentItem[key] instanceof Array) {
                        const elements = tableContentItem[key].map((claimWorkNumber, index) => {
                            return (
                                <div className="m-1" key={`${index}_list`}><Space>{claimWorkNumber}</Space></div>
                            )
                        })
                        sections.push(...elements);
                    }
                }
                else if (tableContentItem[key] || tableContentItem[key] == '') {
                    if (currentComponentInstance === COMPONENTS_KEY && key === 'duration') {
                        sections.push(
                            <td key={key} className="td unableMinWidth" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props, tableContentItem[key], key, index, field.fieldType, false)}
                            </td>
                        );
                    } else if (currentComponentInstance === COMPONENTS_KEY && key === 'writer') {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props, tableContentItem[key], key, index, field.fieldType, false)}
                            </td>
                        );
                    }
                    else {
                        let className = 'tableCell';
                        if (currentComponentInstance === 'productContributor' && (field.name === 'avRipRoleCode' || field.name === 'name')) {
                            className = `${className} minWidth`;
                        }
                        sections.push(
                            <td key={key} className={`td ${stateKey === CONTRIBUTORS_KEY && key === 'name' && 'extraWide'}`} title={field.data}>
                                <div className={className}>
                                    {getDataInputType(this.changeTableData, this.props, tableContentItem[key], key, index, field.fieldType, false,
                                        key === ECONOMIC_RIGHT ? tableContentItem[ECONOMIC_RIGHT_DESCRIPTION] : undefined)}
                                </div>
                            </td>
                        );
                    }

                }
                else if (stateKey === COMPONENTS_KEY) {
                    if (key === "Action") {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                <div className="tableCell">
                                    <div key={key} className="arrowIconDiv">
                                        <div className="tableCell">
                                            <IconTextButton
                                                icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                                text={tableContentItem["data"]}
                                                onClick={() => this.props.openInNewTab(tableContentItem)}
                                                disabled={isReadOnly}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        )
                    }
                    else {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props, tableContentItem, key, index, field.fieldType, false)}
                            </td>
                        )
                    }
                }
                else if (stateKey === EDITABLE_FIELDS_GRID) {
                    const nameField = tableContentItem["name"];
                    const item = { value: tableContentItem["data"], inputType: field.fieldType, hidden: tableContentItem["hidden"] as boolean, name: nameField, isReadOnly: false }
                    sections.push(
                        <div key={`${key}_${item["name"]}`} className="td col-lg-6 col-md-6 col-sm-6 col-xs-6" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props,item, field.name, index, field.fieldType, tableContentItem["hidden"] as boolean)}
                        </div>
                    );
                }
                else if (stateKey === PARENT_WORK_KEY) {
                    if (key === OPEN_PARENT) {
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                <div className="tableCell">
                                    <div key={key} className="arrowIconDiv">
                                        <div className="tableCell">
                                            <IconTextButton
                                                icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                                text={"Work"}
                                                onClick={() => this.props.openInNewTab(tableContentItem)}
                                                disabled={isReadOnly}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </td>
                        )
                    }
                    else {
                        const nameField = tableContentItem["name"];
                        const item = { value: tableContentItem[key].value, inputType: field.fieldType, hidden: tableContentItem["hidden"] as boolean, name: nameField, isReadOnly: false }
                        sections.push(
                            <td key={key} className="td" title={field.data}>
                                {getDataInputType(this.changeTableData, this.props,item, key, index, field.fieldType, false)}
                            </td>
                        )
                    }
                }
                else if (stateKey === CONTRIBUTORS_KEY && key === WORK_CONTRIBUTOR_RELATIONSHIPS_STATE_KEY) {
                    const nameField = tableContentItem["name"];
                    const item = { value: tableContentItem["relation"].value, inputType: field.fieldType, hidden: tableContentItem["hidden"] as boolean, name: nameField, isReadOnly: false }
                    sections.push(
                        <td key={key} className="td" title={field.data}>
                            {getDataInputType(this.changeTableData, this.props,item, WORK_CONTRIBUTOR_RELATIONSHIPS_STATE_KEY, index, field.fieldType, false)}
                        </td>)
                }
                else {
                    sections.push(<td key={key} className="td" />)
                }

            });

            if (dependentFields && dependentFieldKey) {
                const items: any[] = tableContentItem[dependentFieldKey];
                if (items) {
                    let i: number = 0;
                    items.map(item => {
                        i++;
                        const rowCells: JSX.Element[] = [];
                        rowCells.push(<td key={i} className="td" />)
                        dependentFields.map(dependentField => {
                            const key: string = dependentFields[0].componentInstance + '.' + dependentField.name;
                            
                            let alignRight = false
                            if (dependentField) {
                                if (isTableAction(dependentField.fieldType)) {
                                    rowCells.push(this.renderRowAction(item, dependentField))
                                }
                                else {
                                    let cellData = item[dependentField.name];
                                    if (dependentField.name === 'ipiNumber')
                                        cellData = RepertoireHelper.zeroPaddedIPINameNumber(isNaN(Number(item['ipiNumber'])) ? "" : item[dependentField.name]);

                                    if (dependentField.name === 'perfPercentage' && agreementShareDisplayOptions != null && agreementShareDisplayOptions.ShowAgreementShares) {
                                        cellData = RepertoireHelper.trailingZeroesForShares(item['performingShareToDisplay'], shareDecimalsToDisplay);
                                        alignRight = true;
                                    }
                                    else if (dependentField.name === 'mechPercentage' && agreementShareDisplayOptions != null && agreementShareDisplayOptions.ShowAgreementShares) {
                                        cellData = RepertoireHelper.trailingZeroesForShares(item['mechanicalShareToDisplay'], shareDecimalsToDisplay);
                                        alignRight = true
                                    }

                                    if (dependentField.name === 'role' && item.agreementCategoryRoleCode != null) {
                                        cellData = item.agreementCategoryRoleCode;
                                    }

                                    rowCells.push(
                                        <td key={key} className={`td ${alignRight ? 'alignRight' : ''}`} title={dependentField.data}>
                                            {cellData}
                                        </td>
                                    );
                                }
                            }
                            else {
                                rowCells.push(<td key={key} className="td" />)
                            }
                        });

                        dependentSections.push(
                            <tr key={index + dependentFieldKey + i} className="tr dependent">
                                {rowCells}
                            </tr>
                        )
                    });
                }
            }

            return { sections, dependentSections };
        }
    };

    renderFieldOptions(field: IRepertoireField, tableContentItem: any, index: number): JSX.Element {
        const {
            dataGridTableData,
            stateKey,
            isReadOnly,
            dataSource,
            lookupValues,
            showModal,
            addNewAccount,
            openInNewTab,
            openInSplitScreen,
            expandedWorkResults,
            expandMatchingWork,
            expandedProductResults,
            expandMatchingProduct
        } = this.props;
        return (stateKey === 'matchingRepertoireWorks' && (!expandedWorkResults || !expandedWorkResults.includes(index)) ?
           <td className="td" title={field.data}>
                <img
                    src={EXTERNAL_SVG}
                    title="Expand title"
                    alt="Right Arrow icon"
                    className={expandedWorkResults && expandedWorkResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                    onClick={() => expandMatchingWork(index)}
                />
                <FieldOptions
                    dataGridTableData={dataGridTableData}
                    stateKey={stateKey}
                    isReadOnly={isReadOnly}
                    dataSource={dataSource}
                    lookupValues={lookupValues}
                    field={field}
                    tableContentItem={tableContentItem}
                    index={index}
                    showModal={showModal}
                    showSearchModal={this.showSearchModal}
                    addNewAccount={addNewAccount}
                    changeTableData={this.changeTableData}
                    openInNewTab={openInNewTab}
                    openInSplitScreen={openInSplitScreen}
                /></td> :
            stateKey === 'matchingRepertoireWorks' && (expandedWorkResults && expandedWorkResults.includes(index)) ?
                <td className="td" title={field.data}>
                    <img
                        src={EXTERNAL_SVG}
                        title="Expand title"
                        alt="Right Arrow icon"
                        className={expandedWorkResults && expandedWorkResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                        onClick={() => expandMatchingWork(index)}
                    />
                    <FieldOptions
                        dataGridTableData={dataGridTableData}
                        stateKey={stateKey}
                        isReadOnly={isReadOnly}
                        dataSource={dataSource}
                        lookupValues={lookupValues}
                        field={field}
                        tableContentItem={tableContentItem}
                        index={index}
                        showModal={showModal}
                        showSearchModal={this.showSearchModal}
                        addNewAccount={addNewAccount}
                        changeTableData={this.changeTableData}
                        openInNewTab={openInNewTab}
                    />
                    <TextDataInput
                        value={tableContentItem.name.length >= 2 ? tableContentItem.name[1].value : ''}
                        fieldName={stateKey}
                        changeData={null}
                        readOnly={true}
                        isHidden={false}
                    />
                    <TextDataInput
                        value={tableContentItem.name.length >= 3 ? tableContentItem.name[2].value : ''}
                        fieldName={stateKey}
                        changeData={null}
                        readOnly={true}
                        isHidden={false}
                    />
                </td> :
                stateKey === 'matchingRepertoireProducts' && (!expandedProductResults || !expandedProductResults.includes(index)) ?
                    <td className="td" title={field.data}>
                        <img
                            src={EXTERNAL_SVG}
                            title="Expand title"
                            alt="Right Arrow icon"
                            className={expandedProductResults && expandedProductResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                            onClick={() => expandMatchingProduct(index)}
                        />
                        <FieldOptions
                            dataGridTableData={dataGridTableData}
                            stateKey={stateKey}
                            isReadOnly={isReadOnly}
                            dataSource={dataSource}
                            lookupValues={lookupValues}
                            field={field}
                            tableContentItem={tableContentItem}
                            index={index}
                            showModal={showModal}
                            showSearchModal={this.showSearchModal}
                            addNewAccount={addNewAccount}
                            changeTableData={this.changeTableData}
                            openInNewTab={openInNewTab}
                        />
                    </td> :
                    stateKey === 'matchingRepertoireProducts' && (expandedProductResults && expandedProductResults.includes(index)) ?
                        <td className="td" title={field.data}>
                            <img
                                src={EXTERNAL_SVG}
                                title="Expand title"
                                alt="Right Arrow icon"
                                className={expandedProductResults && expandedProductResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                                onClick={() => expandMatchingProduct(index)}
                            />
                            <FieldOptions
                                dataGridTableData={dataGridTableData}
                                stateKey={stateKey}
                                isReadOnly={isReadOnly}
                                dataSource={dataSource}
                                lookupValues={lookupValues}
                                field={field}
                                tableContentItem={tableContentItem}
                                index={index}
                                showModal={showModal}
                                showSearchModal={this.showSearchModal}
                                addNewAccount={addNewAccount}
                                changeTableData={this.changeTableData}
                                openInNewTab={openInNewTab}
                            />
                            <TextDataInput
                                value={tableContentItem.name.length >= 2 ? tableContentItem.name[1].value : ''}
                                fieldName={stateKey}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                            />
                            <TextDataInput
                                value={tableContentItem.name.length >= 3 ? tableContentItem.name[2].value : ''}
                                fieldName={stateKey}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                            />
                        </td> :
                        <td className="td" title={tableContentItem[field.name].value ? tableContentItem[field.name].value : field.data} >
                            <FieldOptions
                                dataGridTableData={dataGridTableData}
                                stateKey={stateKey}
                                isReadOnly={isReadOnly}
                                dataSource={dataSource}
                                lookupValues={lookupValues}
                                field={field}
                                tableContentItem={tableContentItem}
                                index={index}
                                showModal={showModal}
                                showSearchModal={this.showSearchModal}
                                addNewAccount={addNewAccount}
                                changeTableData={this.changeTableData}
                                openInNewTab={openInNewTab}
                            />
                        </td>
        );
    }

    getHeaderSections = () => {
        const { dataGridTableData, componentInstance, showRowNumber, allowMultiSelectChbk, isBulkCheckboxActive, 
            usageType, tableContents, activeSetType, checkableColumns = [], isRowSelectionEnabled = false } = this.props;
        const { activeSortHeaderSection, checkedColumns } = this.state;
        let currentComponentInstance = componentInstance;

        if (componentInstance === SET_LISTS_WORK_SEARCHVIEW_STATE_KEY) {
            currentComponentInstance = DRAFT_SET_LISTS_WORK_STATE_KEY;
        }
        const editableGridFields = currentComponentInstance === EDITABLE_FIELDS_GRID ? 'td col-lg-6 col-md-6 col-xs-6' : 'td'
        if (dataGridTableData && dataGridTableData.fields) {
            let filteredFields: IRepertoireField[] = dataGridTableData.fields.filter(
                (field: IRepertoireField) => field.componentInstance === currentComponentInstance);

            if (currentComponentInstance === CONTRIBUTORS_KEY || currentComponentInstance === IP_NAMES_KEY || currentComponentInstance === USAGE_ROWS_SECTION_KEY) {
                if(activeSetType != OTHER_KEY){
                    filteredFields = filteredFields.filter(x => !x.hidden && x.name != "includeTerritories" && x.name != "excludeTerritories");
                }

                filteredFields = filteredFields.filter(x => !x.hidden);
            }
            let fieldsToRender = filteredFields;
            if ((currentComponentInstance === CONTRIBUTORS_KEY || currentComponentInstance === USAGE_ROWS_SECTION_KEY) && filteredFields.length > 0) {
                fieldsToRender = ComponentsHelper.orderFieldsBySpecificField(filteredFields, 'order');
            }

            const totalPerfPercentage = Number(
                (tableContents ?? [])
                    .reduce((sum: number, item: any) => sum + (Number(item?.perfPercentage?.value ?? 0)), 0)
            ).toFixed(2);

            const totalMechPercentage = Number(
                (tableContents ?? [])
                    .reduce((sum: number, item: any) => sum + (Number(item?.mechPercentage?.value ?? 0)), 0)
            ).toFixed(2);

            const getSectionData = (section: any, usageType: string) => {
                if (usageType === "SET LIST") {
                    return this.changeDataForLivePerformance(section.data);
                }

                if (section.componentInstance === CONTRIBUTORS_KEY) {
                    switch (section.name) {
                        case 'perfPercentage':
                            return (
                                <>
                                    <div className="tableHeaderSectionContainer">
                                        {section.data}
                                        <div className="tableHeaderSectionValue">{totalPerfPercentage}</div>
                                    </div>
                                </>
                            );
                        case 'mechPercentage':
                            return (
                                <>
                                    <div className="tableHeaderSectionContainer">
                                        {section.data}
                                        <div className="tableHeaderSectionValue">{totalMechPercentage}</div>
                                    </div>
                                </>
                            );
                        default:
                            return section.data;
                    }
                }

                return section.data;
            };

            const renderHeaderCheckbox = (sectionName: string) => {
                return (
                    <div className="headerCell" data-testid={'header-checkbox'}>
                            <CheckboxDataInput
                                label=""
                                fieldName=""
                                value={isBulkCheckboxActive}
                                changeData={(value) =>
                                    this.changeTableDataForMultiSelect(value, sectionName)
                                }
                                readonly={false}
                                isHidden={!allowMultiSelectChbk}
                            />
                        </div>
                )
            }

            const headerSections = fieldsToRender.map((section: IRepertoireField, index: number) => (

                <td key={section.name} className={`${editableGridFields} ${section.componentInstance === COMPONENTS_KEY && (section.name === 'title')
                    ? "col-lg-6 col-md-6 col-xs-6" : section.componentInstance === COMPONENTS_KEY && (section.name === 'number' || section.name === 'writer') ?
                        "col-lg-3 col-md-3 col-xs-3" : section.componentInstance === 'productContributor' && (section.name === 'avRipRoleCode' || section.name === 'name') ? 'col-lg-4 col-md-4 col-sm-4'
                            : EMPTY_STRING_VALUE}`}>
                    {isRowSelectionEnabled && index === 0 && renderHeaderCheckbox(section.name)}
                    {section.name === 'selected' || (currentComponentInstance === DISTRIBUTION_POOLS_KEY && section.name === 'selected' && allowMultiSelectChbk === true) ?
                        renderHeaderCheckbox(section.name)
                        :
                        <TableHeaderSection
                            section={getSectionData(section, usageType)}
                            fieldName={section.name}
                            isSortingActive={section.name === activeSortHeaderSection}
                            ascending={this.ascending}
                            onClickHeaderSection={this.sortTableByColumn}
                            sortable={(currentComponentInstance === EDITABLE_FIELDS_GRID) ? false : !isTableAction(section.fieldType)}
                            checkable={checkableColumns.includes(section.name)}
                            isChecked={checkableColumns.includes(section.name) ? checkedColumns.includes(section.name) : undefined}
                            onCheckboxChange={checkableColumns.includes(section.name) ? this.handleHeaderCheckboxChange : undefined}
                        />
                    }
                </td>
            ));

            if (showRowNumber && currentComponentInstance !== IP_LICENSING_REPRESENTATION_KEY) {
                headerSections.splice(0, 0, <td key="rowNumber" title="Row Number"></td>);
            }
            return headerSections;
        }
    };

    showSearchModal = (modalProps: any, searchViewKey: string, index?: number) => {
        const { showModal, componentInstance, dataSource, stateKey } = this.props;
        if(stateKey!==IP_REPRESENTATION_KEY && stateKey!=='draftAgreementsApplicableWorks'){
            clearModalSearchResults();
        }

        if (componentInstance == PRODUCT_WORKS_KEY && dataSource == DataSource.Repertoire) {
            searchViewKey = PRODUCT_WORKS_REPERTOIRE_STATE_KEY;
        }
        else if (componentInstance == COMPONENTS_KEY && dataSource == DataSource.Repertoire) {
            searchViewKey = COMPONENTS_WORKS_REPERTOIRE_STATE_KEY;
        }
        else if (componentInstance == USAGE_MATCHING_WORKS_SECTION_KEY && stateKey == MATCHINGWORKS_KEY) {
            searchViewKey = USAGE_MATCHING_WORKS_SECTION_KEY;
        }
        else if (componentInstance == USAGE_MATCHING_WORKS_SECTION_KEY && stateKey == MATCHINGPRODUCTS_KEY) {
            searchViewKey = USAGE_MATCHING_PRODUCTS_SECTION_KEY;
        }
        if (searchViewKey == USAGE_MATCHING_WORKS_SECTION_KEY) {
            showModal(USAGESEARCH_VIEW, USAGE_MATCHING_WORKS_SECTION_KEY, modalProps, true, "Search Work To Match");
        }
        else if (searchViewKey == USAGE_MATCHING_PRODUCTS_SECTION_KEY) {
            showModal(USAGESEARCH_VIEW, USAGE_MATCHING_PRODUCTS_SECTION_KEY, modalProps, true, "Search Product To Match");
        }
        else if ((stateKey === IP_REPRESENTATION_KEY || stateKey === CONTRIBUTORS_KEY) && searchViewKey === 'Territory Include') {
            showModal(TERRITORY_SELECTION_VIEW, stateKey, modalProps, true, "Territory Include", '', false, '', index)
        }
        else if ((stateKey === IP_REPRESENTATION_KEY || stateKey === CONTRIBUTORS_KEY) && searchViewKey === 'Territory Exclude') {
            showModal(TERRITORY_SELECTION_VIEW, stateKey, modalProps, true, "Territory Exclude", null, null, null, index)
        }
        else if (stateKey === IP_REPRESENTATION_KEY && searchViewKey === 'Pools Exclude') {
            showModal(POOL_SELECTION_VIEW, null, modalProps, true, "Pools Exclude", null, null, null, index)
        }
        else if (stateKey === IP_REPRESENTATION_KEY && searchViewKey === 'Pools Include') {
            showModal(POOL_SELECTION_VIEW, null, modalProps, true, "Pools Include", null, null, null, index)
        }
        else if (stateKey === "draftAgreementsComments"){
            showModal(DRAFT_AGREEMENTS_PAGE_VIEW, DRAFT_AGREEMENTS_PAGE_VIEW, modalProps, true, "Comments", '', false, 'modalSearch', index);
        }
        else if (stateKey === "DraftAgreementsMaintenanceAssigneeView"){
            showModal(SEARCH_VIEW, 'ips', modalProps, true, "Select IP", '', false, 'agreementsAssignee', index);
        }
        else if(stateKey === USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY){
            showModal(USAGE_MAINTENANCE_COMMENTS_MODAL, USAGE_MAINTENANCE_COMMENTS_MODAL, modalProps, true, "Comment Details", '', false, '', index);
        }
        else if (stateKey === AGREEMENT_CARVEOUTS_KEY) {
            showModal(SEARCH_VIEW, AGREEMENT_CARVEOUT_PRODUCTS_KEY, modalProps, true, "Search Product");
        }
        else {
            showModal(SEARCH_VIEW, searchViewKey, modalProps, true, "Search", null, null, null, index);
        }
    };

    dependentRowAction(tableContentItem: any) {
        const { dependentRowAction } = this.props;
        dependentRowAction(tableContentItem);
    }

    renderRowAction = (tableContentItem: any, field: IRepertoireField): JSX.Element => {
        const { stateKey, componentInstance, isReadOnly, tabs, activeTab, tableActions, showModal, openInNewTab } = this.props;

        const tableActionName: ITableActionName = field.fieldType as ITableActionName;
        const tableAction = (tableActions || []).filter(e => e.name === tableActionName);
        let isDisabledSpecified = tableAction[0] ? tableAction[0].disabled !== undefined : false;

        switch (tableActionName) {
            case OPEN_ACTION: {
                return (
                    <td className="td" key={OPEN_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                text={""}
                                onClick={() => this.onClickOpen(field, tableContentItem)}
                                disabled={isDisabledSpecified ? tableAction[0].disabled : isReadOnly}
                            />
                        </div>
                    </td>
                );
            }
            case ADD_NEW_ACTION: {
                return (
                    <td className="td" key={ADD_NEW_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={field.data}
                                onClick={() => this.onClickAdd()}
                                disabled={isReadOnly}
                            />
                        </div>
                    </td>
                );
            }
            case ADD_COVER_VERSION_ACTION: {
                return (
                    <td className="td" key={ADD_COVER_VERSION_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={field.data}
                                onClick={() => this.onClickAdd()}
                                disabled={isReadOnly}
                            />
                        </div>
                    </td>
                );
            }
            case ADD_NEW_DATE_ACTION: {
                return (
                    <td className="td" key={ADD_NEW_DATE_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={field.data}
                                onClick={() => this.onClickAdd()}
                                disabled={isReadOnly}
                            />
                        </div>
                    </td>
                );
            }

            case REMOVE_ACTION: {
                return (
                    <td className="td" key={REMOVE_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={field.data}
                                onClick={() => this.onClickRemove(tableContentItem)}
                                disabled={isReadOnly || (stateKey == DISTRIBUTION_POOLS_KEY && tableContentItem.status.value === 'Allocated')}
                            />
                        </div>
                    </td>
                );
            }
            case SEARCH_ACTION: {
                return (
                    <td className="td" key={SEARCH_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--Delete"}
                                text={field.data}
                                onClick={() => this.showSearchModal(tableContentItem, componentInstance)}
                                disabled={isReadOnly}
                            />
                        </div>
                    </td>
                );
            }
            case DEPENDENT_ROW_ACTION: {
                let disable = isReadOnly;
                if (componentInstance === CONTRIBUTORS_KEY) {
                    disable = tabs[activeTab].isReadonly;
                }
                return (
                    <td className="td" key={DEPENDENT_ROW_ACTION}>
                        <div className="tableCell">
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--OpenInNewTab"}
                                text={field.data}
                                onClick={() => this.dependentRowAction.bind(this)(tableContentItem)}
                                disabled={disable}
                            />
                        </div>
                    </td>
                );
            }
            case CODE_ACTION: {
                const key = CODE_ACTION.concat('_').concat(tableContentItem.workSubmissionID).concat(field.name === WORK_SUBMISSION ? WORK_SUBMISSION : WORK_RESPONSE);
                const code = field.name === WORK_SUBMISSION ? tableContentItem.submission : tableContentItem.response;
                return (

                    <td className="td" key={key}>
                        <div className="tableCell hasCode">
                            <code>{code}</code>
                            <IconTextButton
                                icon={"icon ms-Icon ms-Icon--FullScreen"}
                                text=''
                                onClick={() => this.onOpenCodeModel(field.name === WORK_SUBMISSION ? tableContentItem.submission : tableContentItem.response, field.data)}
                                disabled={isReadOnly}
                            />
                        </div>
                    </td>
                );
            }
            case GROUPED_ACTION: {

                return (
                    <td className="td" key={field.name}>
                        <div className="tableCell">
                            {this.renderGroupedActions(tableContentItem, field)}
                        </div>
                    </td>
                );
            }
            case MERGE_ACTION:
                {
                    let disabled = false;
                    const { repertoireAgreementID } = tableContentItem;
                    disabled =!repertoireAgreementID.value;
                    return (
                        <td className="td" key={field.name}>
                            <div className="tableCell">
                                <button disabled={disabled} type="button" key={field.name} title="Merge" onClick={() => this.props.mergeActionClick(tableContentItem)} className="button btn-defaultSecondary mergeButton" >
                                    Merge
                                </button>
                            </div>
                        </td>
                    );
                }
            default: {
                return null;
            }
        }
    };

    renderGroupedActions = (tableContentItem: any, field: IRepertoireField): JSX.Element => {
        const actions = JSON.parse(field.additionalData);
        const buttons: JSX.Element[] = [];
        const dropdowns: JSX.Element[] = [];
        let i = 0;

        let disabled = false;
        let disableAll = false;
        if (tableContentItem.isDefinite.value == true) {
            if (actions.hasOwnProperty(ManualMergeOptions.PostNew)) {
                delete actions[ManualMergeOptions.PostNew];
            }
        }
        else if (tableContentItem?.isDefinite?.value == false) {
            disabled = true;
        }

        if (tableContentItem?.name?.value == "" && tableContentItem?.number?.value == "") {
            disableAll = true;
        }

        if (actions) {
            for (const x in actions) {

                if (i === 0) {
                    buttons.push(<button disabled={disableAll} type="button" key={i} title={actions[x]} onClick={() => this.props.groupActionClick(x, tableContentItem)} className="button btn-defaultSecondary" ><div className='overflowEllipsis widthJoinedButton flexRow'>{actions[x]}</div></button>);
                    buttons.push(<button disabled={disableAll} title="More options" key={-1} type="button" className="button btn-defaultSecondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span className="caret"></span>
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>);
                }
                else {
                    dropdowns.push(
                        <NavItem key={i}>
                            <NavLink disabled={disableAll} onClick={() => this.props.groupActionClick(x, tableContentItem)}>{actions[x]}</NavLink>
                        </NavItem>
                    )
                }
                i = i + 1;
            }
        }

        buttons.push(
            <ul className="dropdown-menu" key={-2}>
                {dropdowns}
            </ul>
        )
        return (
            <div className="btn-group splitButton">
                {buttons}
            </div>
        );
    }

    renderTableActions = () => {
        const { tableActions } = this.props;
        return (<div>
            {tableActions && tableActions.map((ta, index) => this.renderTableAction(ta, index))}
        </div>);
    }

    renderTableAction = (tableAction: ITableAction, index: number) => {
        const { componentInstance, dataGridTableData, isReadOnly, openWorkFlow, tableContents, onClickCopy = () => {} } = this.props;
        switch (tableAction.name) {
            case ADD_NEW_ACTION: {
                return (
                    <SizedActionButton key={index}
                        buttonText={dataGridTableData.fields.find(f => f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY && f.name === ADD_NEW_ACTION).data}
                        buttonAction={this.onClickAdd}
                        disabled={tableAction.disabled || isReadOnly}
                    />
                );
            }
            case COPY_ACTION: {
                const isThereAtLeastOneCopyCheckBoxSelected = tableContents && tableContents.length > 0 && tableContents?.find(line => {
                    return line && line?.copySection?.value
                });
                return (
                    <SizedActionButton key={index}
                        buttonText={dataGridTableData.fields.find(f => f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY && f.name === COPY_ACTION).data}
                        buttonAction={onClickCopy}
                        disabled={tableAction.disabled || isReadOnly || !isThereAtLeastOneCopyCheckBoxSelected}
                    />
                );
            }
            case ADD_COVER_VERSION_ACTION: {
                return (
                    <SizedActionButton key={index}
                        buttonText={dataGridTableData.fields.find(f => f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY && f.name === ADD_COVER_VERSION_ACTION).data}
                        buttonAction={this.onClickAdd}
                        disabled={tableAction.disabled || isReadOnly}
                    />
                );
            }
            case ADD_NEW_DATE_ACTION: {
                return (
                    <SizedActionButton key={index}
                        buttonText={formatDateToHourAndMinutes(dataGridTableData.fields.find(f => f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY && f.name === ADD_NEW_DATE_ACTION).data)}
                        buttonAction={this.onClickAdd}
                        disabled={tableAction.disabled || isReadOnly}
                    />
                );
            }

            case SEARCH_ACTION: {
                return (
                    <SizedActionButton key={index}
                        buttonText={dataGridTableData.fields.find(f => f.componentInstance === TABLE_ACTIONS_INSTANCE_KEY && f.name === SEARCH_ACTION).data}
                        buttonAction={() => this.showSearchModal(null, componentInstance)}
                        disabled={tableAction.disabled || isReadOnly || openWorkFlow}
                    />
                );
            }
            default: {
                return null;
            }
        }
    };

    renderHeader = () => {
        const {
            isExpandable
        } = this.props
        let sections = this.getHeaderSections();
        return <tr key="headerRow" className="tr">{isExpandable && <td />}{sections}</tr>;
    };

    handleDrop = (newOrder, e, droppedOnItem, tableContents) => {
        newOrder = newOrder - 1;

        e.target.classList.remove('js-active');
        const droppeddItem: IRepertoireField = JSON.parse(e.dataTransfer.getData('text/plain'));

        const dataTableFields: IRepertoireField[] = tableContents.filter(x => x.componentInstance === CONTRIBUTORS_KEY);

        let originalFieldPosition: number = 0;
        for (var i = 0; i < dataTableFields.length; i++) {
            if (dataTableFields[i].name === droppeddItem.name) {
                originalFieldPosition = i;
                break;
            }
        }

        this.changeTableData(droppedOnItem, EDITABLE_FIELDS_GRID, SEQUENCE_FIELD, originalFieldPosition, EDITABLE_FIELDS_GRID, newOrder);
    }

    handleDragLeave = (index, e, tableContentItem, tableContents) => {
        e.target.classList.remove('js-active');
    }

    handleDragEnd = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragEnter = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragOver = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragStart = (index, e, draggedItem, tableContents) => {
        e.dataTransfer.setData('text/plain', JSON.stringify(draggedItem));
    }

    updateContentsTable(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number): void {
        this.setState({ indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage });
    }

    renderPaginationView(): JSX.Element {
        const { tableContents } = this.props;
        const {resultsPerPage, currentPage } = this.state;
        return <PaginationView
            contentsLength={tableContents ? tableContents.length : 0}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            updateContentsTable={this.updateContentsTable.bind(this)}
            componentInstance="numbers"
        />
    }
    renderTableContents = () => {
        const { tableContents, isExpandedUsageMatchingSection, componentInstance, customFields, pool, dataGridTableData, isExpandable, stateKey, changeData, expandedUsageDetailsRow, addUsageDetailsShareIPRow, lookupValues, showModal, portalType, resetMessageBanner, openWorkFlow } = this.props;
        const { focusedRow, currentPage, resultsPerPage } = this.state;
        const rows: JSX.Element[] = [];
        if (tableContents) {
            let fieldsToRender: any = tableContents;
            if (componentInstance === 'numbers'){
                const startIndex = (currentPage - 1) * resultsPerPage;
                const endIndex = startIndex + resultsPerPage;
                fieldsToRender = tableContents.slice(startIndex, endIndex).map((tableContentItem, index) => ({
                    ...tableContentItem,
                    originalIndex: startIndex + index
                }));
            }
            if (componentInstance === CONTRIBUTORS_KEY || componentInstance === EDITABLE_FIELDS_GRID || componentInstance === DRAFT_AGREEMENTS_COMMENTS_STATE_KEY) {
                let fields: any[] = [];
                if (fieldsToRender.length === undefined) {
                    Object.keys(fieldsToRender).map(function (key) {
                        fields.push(fieldsToRender[key])
                    })
                    fieldsToRender = ComponentsHelper.orderFieldsBySpecificField(fields as IRepertoireField[], 'order');
                }
                else {
                    fieldsToRender = ComponentsHelper.orderFieldsBySpecificField(fieldsToRender as IRepertoireField[], 'order');
                }
            }
            fieldsToRender && fieldsToRender.map((tableContentItem: any, index: any) => {
                if (componentInstance === 'numbers'){
                    index = tableContentItem.originalIndex;
                }

                const items = this.getTableSections(tableContentItem, index);
                const sections: JSX.Element[] = items.sections;
                const dependentSections: JSX.Element[] = items.dependentSections;
               
                if (componentInstance != "contributors" && isTableAction(tableContentItem.value)) {
                    sections.push(this.renderRowAction(tableContentItem, index))
                }
                else if (componentInstance === "instrumentation" && tableContentItem.type.value === 'CUSTOM' && portalType !== MEMBERS_PORTAL) {
                    if (!customFields || !customFields.includes(index)) {
                        this.props.enableCustomField(index);
                    }
                } else if (componentInstance === "instrumentation" && tableContentItem.type.value !== 'CUSTOM' && portalType !== MEMBERS_PORTAL) {
                    if (customFields && customFields.includes(index)) {
                        this.props.enableCustomField(index);
                    }
                }
                else {
                    sections[sections.findIndex(e => e.key === "remove")] = this.renderRowAction(tableContentItem, index);
                }


                if (componentInstance === EDITABLE_FIELDS_GRID) {
                    rows.push(
                        <div key={index++} draggable={true} className="row daggableItem"
                            onDrop={e => this.handleDrop(index, e, tableContentItem, tableContents)}
                            onDragLeave={e => this.handleDragLeave(index, e, tableContentItem, tableContents)}
                            onDragEnd={e => this.handleDragEnd(index, e, tableContentItem, tableContents)}
                            onDragOver={e => this.handleDragOver(index, e, tableContentItem, tableContents)}
                            onDragEnter={e => this.handleDragEnter(index, e, tableContentItem, tableContents)}
                            onDragStart={e => this.handleDragStart(index, e, tableContentItem, tableContents)}>
                            {sections}
                        </div>

                    )

                } else if (componentInstance === USAGE_ROWS_SECTION_KEY) {
                    let usageGridData = dataGridTableData;
                    if (pool && pool.datesAndDimensions.length > 0) {
                        pool.datesAndDimensions.map(element => {
                            var startDate = new Date(element.effectiveFrom);
                            var endDate = element.effectiveTo != null ? new Date(element.effectiveTo) : new Date();
                            var dateToCheck = new Date(tableContentItem.usageDate.value);
                            if (dateToCheck >= startDate && dateToCheck <= endDate) {
                                tableContentItem.use.inputType = element.use ? 'text' : 'row';
                                tableContentItem.dimension1.inputType = element.dimension1 ? 'text' : 'row';
                                tableContentItem.dimension2.inputType = element.dimension2 ? 'text' : 'row';
                                tableContentItem.dimension3.inputType = element.dimension3 ? 'text' : 'row';
                                tableContentItem.dimension4.inputType = element.dimension4 ? 'text' : 'row';
                                tableContentItem.dimension5.inputType = element.dimension5 ? 'text' : 'row';
                            }
                            else {
                                tableContentItem.use.inputType = 'row';
                                tableContentItem.dimension1.inputType = 'row';
                                tableContentItem.dimension2.inputType = 'row';
                                tableContentItem.dimension3.inputType = 'row';
                                tableContentItem.dimension4.inputType = 'row';
                                tableContentItem.dimension5.inputType = 'row';
                            }
                        })
                    } else {
                        tableContentItem.use.inputType = 'row';
                        tableContentItem.dimension1.inputType = 'row';
                        tableContentItem.dimension2.inputType = 'row';
                        tableContentItem.dimension3.inputType = 'row';
                        tableContentItem.dimension4.inputType = 'row';
                        tableContentItem.dimension5.inputType = 'row';
                    }
                    rows.push(
                        <UsageRowView
                            onRowClick={() => this.onRowClick(index)}
                            onExpandAllClicked={null}
                            key={index}
                            usage={tableContentItem}
                            index={index}
                            dataGridTableData={usageGridData}
                            lookupValues={lookupValues}
                            changeData={changeData}
                            showModal={showModal}
                            addUsageDetailsShareIPRow={addUsageDetailsShareIPRow}
                            tableContents={tableContents}
                            resetMessageBanner={resetMessageBanner}
                            focusedRowNumber={focusedRow}
                            expandedUsageDetailsRow={expandedUsageDetailsRow}
                        />
                    );
                }
                else if (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY || componentInstance === USAGE_LICENSE_MATCHING) {
                    rows.push(
                        <DataGridTableRow
                            onRowClick={() => this.onRowClick(index)}
                            dataGridTableData={dataGridTableData}
                            stateKey={stateKey}
                            componentInstance={componentInstance}
                            tableContentsItem={tableContentItem}
                            key={index}
                            index={index}
                            changeData={changeData}
                            tableContents={tableContents}
                            isExpandable={isExpandable}
                            dependentRowAction={this.dependentRowAction.bind(this)}
                            clearAllRowsButThis={this.props?.clearAllRowsButThis?.bind(this)}
                            openWorkFlow={openWorkFlow}
                            focusedRowNumber={focusedRow}
                            isExpandedUsageMatchingSection={isExpandedUsageMatchingSection}
                        />
                    );
                }
                else if (componentInstance === IP_LICENSING_REPRESENTATION_KEY) {
                    rows.push(
                        <DataGridTableRow
                            onRowClick={() => this.onRowClick(index)}
                            dataGridTableData={dataGridTableData}
                            stateKey={stateKey}
                            componentInstance={componentInstance}
                            tableContentsItem={tableContentItem}
                            key={index}
                            index={index}
                            changeData={changeData}
                            tableContents={tableContents}
                            isExpandable={isExpandable}
                            dependentRowAction={this.dependentRowAction.bind(this)}
                            updateIpRepresentationsIdsToRemove={this.updateIpRepresentationsIdsToRemove.bind(this)}
                            focusedRowNumber={focusedRow}
                        />
                    );
                }
                else if (componentInstance === USAGE_PRODUCT_DETAILS_ROWS_SECTION_KEY) {
                    rows.push(
                        <DataGridTableRow
                            onRowClick={() => this.onRowClick(index)}
                            dataGridTableData={dataGridTableData}
                            stateKey={stateKey}
                            componentInstance={componentInstance}
                            tableContentsItem={tableContentItem}
                            key={index}
                            index={index}
                            tableContents={tableContents}
                            isExpandable={isExpandable}
                            focusedRowNumber={focusedRow}
                        />
                    );
                }
                else {
                    rows.push(<tr key={index} onClick={() => this.onRowClick(index)} className={`tr ${focusedRow === index && 'focusedTableRow'}`}>{sections}</tr>)
                }

                rows.push(...dependentSections);
            });
        }

        return rows;
    };

    renderTableContentByComponent() {
        const { componentInstance } = this.props;

        if (componentInstance === EDITABLE_FIELDS_GRID) {
            return (
                <div className="dragContainer">
                    {this.renderTableContents()}
                </div>
            )
        }
        else {
            return (
                <tbody key="body" className="tbody ">
                    {this.renderTableContents()}
                    {componentInstance === 'numbers' && this.renderPaginationView()}
                </tbody>
            )
        }
    }

    renderTableByComponent() {
        const { componentInstance, stateKey } = this.props;
        if (componentInstance === EDITABLE_FIELDS_GRID) {
            return (
                <>
                    <table className={["table", stateKey].join(" ")}>
                        <thead key="thead" className={"thead"}>
                            {this.renderHeader()}
                        </thead>
                    </table>
                    {this.renderTableContentByComponent()}
                </>
            )
        }
        else {
            return (
                <table className={["table", stateKey].join(" ")}>
                    <thead key="thead" className={"thead"}>
                        {this.renderHeader()}
                    </thead>
                    {this.renderTableContentByComponent()}
                </table>
            )
        }
    }

    render() {
        const { componentInstance } = this.props;
        let className: string = 'tableContainerModal';

        if (componentInstance === 'contributors') {
            className = 'tableContainer';
        }

        else if (componentInstance !== EDITABLE_FIELDS && componentInstance !== EDITABLE_FIELDS_GRID) {
            className = 'row tableContainer';
        }

        const isEditableTable = (componentInstance === EDITABLE_FIELDS || componentInstance === EDITABLE_FIELDS_GRID) ? true : false;
        
        return (
            <>
                <div id={'data-grid-table-' + componentInstance } key="table" className={className} ref={this.componentRef}>
                    <ListenToShortCutKeysDataGridTable
                        showSearchModal={this.showSearchModalShortCutKey.bind(this)}
                        addRow={this.addRowShortCutKeys.bind(this)}
                        deleteRow={this.deleteRowShortCutKeys.bind(this)}
                        handleClickOutside={this.handleClickOutside.bind(this)} />
                <div className={`col-md-12 ${componentInstance}`}>
                        {this.renderTableByComponent()}
                    </div>
                </div>
                <If condition={!isEditableTable}>
                    <div key="actions container" className="row tableContainer">
                        {this.renderTableActions()}
                    </div>
                </If>
            </>
        );
    }
}